import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const SearchableSelect = ({
  name,
  label,
  value,
  error,
  options,
  readOnly,
  onChange,
  className,
  placeholder,
  clearValue,
  isClearable,
}) => {
  const inputId = `${name}-searchable-select`;
  const selectOptions = options.map(option => ({
    value: option.value,
    label: option.text,
  }));
  const selectedOption = selectOptions.find(option => option.value === value) || null;

  const handleChange = selected => {
    onChange({
      target: {
        name,
        value: selected ? selected.value : clearValue,
      },
    });
  };

  return (
    <div className={`form-group ${className}`}>
      <label htmlFor={inputId}>
        <strong>{label}</strong>
      </label>
      <div className="field mt-1">
        <Select
          inputId={inputId}
          value={selectedOption}
          onChange={handleChange}
          options={selectOptions}
          isDisabled={readOnly}
          isClearable={isClearable}
          placeholder={placeholder}
          classNamePrefix="searchable-select"
        />
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </div>
    </div>
  );
};

SearchableSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    text: PropTypes.string.isRequired,
  })),
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  clearValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isClearable: PropTypes.bool,
};

SearchableSelect.defaultProps = {
  value: "",
  error: "",
  options: [],
  readOnly: false,
  className: "",
  placeholder: "Wybierz...",
  clearValue: "",
  isClearable: true,
};

export default SearchableSelect;
